/**
 * This resolver gets called whenever ADFS returns from the login section. This means
 * that the resolver function will try to retrieve a token by the use of the code
 * provided by ADFS in the URL parameter.
 */
import {Location} from '@angular/common';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

import {jwtDecode} from 'jwt-decode';
import {NGXLogger} from 'ngx-logger';
import {SessionService} from '../../shared/service/session.service';
import {AuthenticationService} from '../service/authentication.service';

@Injectable()
export class AuthenticationResolver {

  constructor(
    private logger: NGXLogger,
    private authService: AuthenticationService,
    private location: Location,
    private sessionService: SessionService,
    private router: Router
  ) {
    this.logger.debug('constructing Auth resolver.');
  }

  resolve(): void {
    const code: string = this.getAuthCodeFromUrl(this.location.path(false));

    this.authService.getToken(this.authService.createTokenRequestData(code)).subscribe((data) => {
      this.logger.debug('AuthResolver: token retrieved');

      this.sessionService.setAccessTokenInMemory(data['access_token']);
      this.sessionService.setAccessTokenInStorage(data['access_token']);

      const decodedToken: any = this.decodeAccessToken(data);

      this.sessionService.setCurrentUserFromToken(decodedToken);

      this.router.navigate(['app/sensors']);
    });
  }

  getAuthCodeFromUrl(url: string): string {
    return url.slice(url.indexOf('code=') + 5);
  }

  decodeAccessToken(encodedAccessToken: object): object {
    return jwtDecode(encodedAccessToken['access_token']);
  }
}
